export { DEFAULT_UNIT, stripUnit, unit, unitStrict } from '@apparel/core/styles/unit';
